export const useMotorsSearch = () => {
  const onSelectOption = (value: string) => console.log(value);

  return {
    onSelectOption,
  };
};
